<template>
  <div notice>
    <div class="wrapper">
      <top-visual type="notice">
        <h2>NOTICE</h2>
        <h3>가인패드에서 알려드리는 <br class="hidden-lg-up">공지사항입니다</h3>
      </top-visual>
      <div class="inner-wrap">
        <section class="search">
          <form @submit.prevent="updateList">
            <input type="text" v-model="search">
            <a class="btn-search" @click="updateList"></a>
          </form>
        </section>
        <section class="list">
          <ul class="hidden-lg-up">
            <li v-for="item in listData" :key="item.SQ">
              <router-link :to="`/notice/${item.SQ}`">
                <p><span v-if="item.FIXED === 1">공지</span>{{ item.TITLE }}</p>
                <p class="date">{{ item.REG_DTT }}</p>
              </router-link>
            </li>
          </ul>
          <table class="hidden-md-down">
            <colgroup><col width="80px"/><col width="auto"/><col width="130px"/></colgroup>
            <thead>
            <tr>
              <th>NO</th>
              <th>제목</th>
              <th>날짜</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in listData" :key="item.SQ">
              <td>{{ pageResult.listCount - (pageResult.pageNo - 1)*perPage - index }}</td>
              <td @click="$router.push(`/notice/${item.SQ}`)"><span v-if="item.FIXED === 1">공지</span>{{ item.TITLE }}</td>
              <td>{{ item.REG_DTT }}</td>
            </tr>
            </tbody>
          </table>
          <pagination :result="pageResult" @go="changePage"/>
        </section>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  @import "../less/gynpad";
  @import "../less/asset";
  [notice] { .rel; overflow:hidden; }

  .inner-wrap { margin:0 25px; }
  .search { margin:25px 0 15px; .rel;
    input { .block; padding:0 10px; width:100%; height:40px; line-height:40px; background:#fff; .border(#cbcbcb); border-radius:20px; .border-box; }
    .btn-search { .block; .rt(20px,50%); margin-top:-10px; .wh(20px); background:url("@{common}/ico-search.png") no-repeat; background-size:contain; }
  }

  .list { .border-t(#323841,2px);
    li { padding:15px 0; .border-b(#eee);
      a { .block; .rel; }
      p:first-child { .fs(1.25rem); .medium;
        span { .ib; .vam; height:24px; line-height:24px; .border(#ccc); border-radius:12px; color:#f97d8d; margin-right:12px; padding:0 12px;}
      }
      p.date { margin-top:15px; .tr; }
    }
    .more { .block; .ir; .rm-v(30); .rh(50); .contain('@{story}/more.png'); .bg-c; }
  }

  @media (min-width: @screen-lg-min) {
    [notice] { padding-bottom:130px; }
    .inner-wrap { margin:0; padding:0 60px; max-width:1200px; .border-box; .m-hc; }
    .search { margin:75px 0 25px; .tr;
      input { .ib; padding:0 15px; width:350px; }
      .btn-search { .block; .rt(20px,50%); margin-top:-10px; .wh(20px); background:url("@{common}/ico-search.png") no-repeat; background-size:contain; }
    }
    .list {
      table { width:100%;
        th { padding:30px 0; .fs(18px); }
        td { .border-v(#ccc); .tc; padding:30px 0; .fs(18px);
          &:nth-child(2) { .tl; padding-left:20px; cursor: pointer;
            span { .ib; .vam; .fs(15px); height:28px; line-height:28px; .border(#ccc); border-radius:14px; color:#f97d8d; margin-right:15px; padding:0 15px; }
          }
          &:nth-child(3) { .fs(14px); }
        }
      }
    }
  }

</style>

<script>
import axios from 'axios';
import handler from '../util/ErrorHandler';
import TopVisual from '../components/TopVisual.vue';
import Pagination from '../components/Pagination.vue';

export default {
  name: 'Notice',
  components: { TopVisual, Pagination },
  data() {
    return {
      pageResult: null,
      listData: null,
      pageNo: 1,
      perPage: 5,
      search: '',
    };
  },
  methods: {
    updateList() {
      axios.get('/api/board/list', {
        params: {
          pageNo: this.pageNo, perPage: this.perPage, TYPE: 'NOTICE', SEARCH: this.search,
        },
      })
        .then(({ data }) => {
          if (data.result === 'no-grant') {
            window.location.href = '/admin/login';
            return;
          }
          this.listData = data.list;
          this.pageResult = data.paging;
        })
        .catch(handler());
    },
    changePage(page) {
      this.pageNo = page;
      this.updateList();
    },
  },
  mounted() {
    this.updateList();
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Notice.vue